import { Form, Row, Col, Select, DatePicker } from "antd";
import { StyledButton } from "../../../../../components/styled-antd";
import { getMajorOptions } from "../utils/get-emajor";
import { getTrainingTypeOption } from "../../summary-employee-request/utils/get-emajor";
import { PATH } from "../constant";
import { useHistory } from "react-router-dom";
import { filterCoursesByRangeDate } from "../../../utils";
import { HOSummaryEmployeeRequestService } from "../../../../../services/human-organization/summary-employee-request.service";
import { useSelector } from "../../../../../store/store";
import { mergeRequests, parseData } from "../utils/transform";
import { exportExcel } from "../utils";

const { RangePicker } = DatePicker;

export function SearchBar({ dataSource, setDataSource }: { dataSource: any[]; setDataSource: any }) {
  const history = useHistory();
  const user = useSelector((state) => state.user);
  const currentUserName = user?.current?.username;

  const [form] = Form.useForm();

  const onFinish = async (values: any) => {
    const data = await HOSummaryEmployeeRequestService.getSummaryApprovedRequests(currentUserName);

    const dataSource = parseData(data);

    const results = [];

    for (const item of dataSource) {
      let data = filterCoursesByRangeDate(item.data, values.createdDateTime);
      // data = filterCoursesByDepartmentCode(
      //   data,
      //   form.getFieldValue("eLocation")
      // );
      if (data && data.length !== 0)
        results.push({
          eMajor: item.eMajor,
          data,
        });
    }

    const results2 = [];
    for (const item of results) {
      let data = item.data.filter((value) => value.eTrainingType === values.eTrainingType);

      if (values.eMajor) {
        data = data.filter((value) => value.eMajor === values.eMajor);
      }

      if (values.eLocation) {
        if (values.eLocation === "NBA") {
          data = data.filter((value) => value?.unit?.includes("Nội Bài"));
        }
        if (values.eLocation === "DAD") {
          data = data.filter((value) => value?.unit?.includes("Đà Nẵng"));
        }
        if (values.eLocation === "TSN") {
          data = data.filter((value) => !value?.unit?.includes("Đà Nẵng") && !value?.unit?.includes("Nội Bài"));
        }
      }

      if (data && data.length !== 0)
        results2.push({
          eMajor: item.eMajor,
          data,
        });
    }

    setDataSource(results2);
  };

  const createRequest = () => {
    history.push({
      state: { dataSource, eLocation: form.getFieldValue("eLocation") },
      pathname: PATH.CREATE.replace(":id", "0"),
    });
  };

  const exportExcelFile = async () => {
    if (!form.getFieldValue("eLocation")) return;

    exportExcel(mergeRequests(dataSource)?.[0], form.getFieldValue("eLocation"));
  };

  return (
    <Form name="basic" onFinish={onFinish} layout="vertical" form={form}>
      <Row justify="space-around">
        <Col span={12} className="px-3">
          <Form.Item
            name="createdDateTime"
            label="Thời gian khoá học"
            rules={[{ required: true, message: "Chọn Thời gian khoá học" }]}
          >
            <RangePicker style={{ width: "100%" }} placeholder={["Từ ngày", "Đến ngày"]} />
          </Form.Item>
        </Col>

        <Col span={12} className="px-3">
          <Form.Item name="eMajor" label="Nghiệp vụ">
            <Select showSearch allowClear options={getMajorOptions()} />
          </Form.Item>
        </Col>

        <Col span={12} className="px-3">
          <Form.Item
            name="eTrainingType"
            label="Loại hình đào tạo"
            rules={[{ required: true, message: "Chọn Loại hình đào tạo" }]}
          >
            <Select showSearch options={getTrainingTypeOption()} />
          </Form.Item>
        </Col>

        <Col span={12} className="px-3">
          <Form.Item
            name="eLocation"
            label="Cơ quan/đơn vị"
            rules={[{ required: true, message: "Chọn Loại hình đào tạo" }]}
          >
            <Select
              showSearch
              options={[
                {
                  value: "TSN",
                  label: "Khối cơ quan/CN Tân Sơn Nhất",
                },
                {
                  value: "DAD",
                  label: "CN Đà Nẵng",
                },
                {
                  value: "NBA",
                  label: "CN Nội Bài",
                },
              ]}
            />
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <StyledButton htmlType="submit" bgColor="blue" className="mx-3">
          LỌC
        </StyledButton>
        <StyledButton bgColor="blue" className="mx-3" onClick={exportExcelFile}>
          XUẤT FILE
        </StyledButton>
        <StyledButton bgColor="blue" className="mx-3" onClick={createRequest}>
          TẠO YÊU CẦU
        </StyledButton>
      </Row>
    </Form>
  );
}
